module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_7042.8794e173.png";